const defaultProps = {
  schemas: [],
};

function OutputPointer({ field, object }) {
  const pointer = object[field];

  if (pointer && field === "supplier") {
    return `${object?.supplier.name || ""} - ${object?.supplier?.city}`;
  } else if (pointer && field === "client") {
    return `${
      object?.client?.clientName || object?.client?.companyName || ""
    } - ${object?.client?.billingCity}`;
  }
  return null;
}

OutputPointer.defaultProps = defaultProps;
export default OutputPointer;
